module.exports = __webpack_public_path__ + "img/faqseal_pic2.ae4f33ee.png";